import { __awaiter, __extends, __generator } from "tslib";
import { Log } from "../utils";
import { getFileExtension, isNullOrEmpty } from "../utils/string";
import { AppModule as CoreAppModule } from "./../core/AppModule";
var AppModule = /** @class */ (function (_super) {
    __extends(AppModule, _super);
    function AppModule(pArticleManager) {
        var _this = _super.call(this) || this;
        _this.mArticleManager = pArticleManager;
        return _this;
    }
    Object.defineProperty(AppModule.prototype, "moduleId", {
        get: function () {
            return (AppModule.MODULE_KEY);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AppModule.prototype, "articleManager", {
        get: function () {
            return (this.mArticleManager);
        },
        enumerable: false,
        configurable: true
    });
    AppModule.prototype.clearDocumentData = function () {
        this.mArticleManager._clear();
    };
    AppModule.prototype.loadDocumentData = function (pContext, pData) {
        return __awaiter(this, void 0, void 0, function () {
            var tBuffer, tSession, tBlob, tUrl;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, pContext.getResource("project.obk", true)];
                    case 1:
                        tBuffer = _a.sent();
                        tSession = this.mArticleManager.session;
                        if (!tSession.isValid) return [3 /*break*/, 5];
                        tBlob = new Blob([tBuffer]);
                        return [4 /*yield*/, tSession.uploadFile("Project", tBlob)];
                    case 2:
                        tUrl = _a.sent();
                        if (isNullOrEmpty(tUrl))
                            throw new Error("Failed to upload obk.");
                        return [4 /*yield*/, tSession.session.loadSession(tUrl)];
                    case 3:
                        _a.sent();
                        return [4 /*yield*/, tSession.deleteFile(tUrl)];
                    case 4:
                        _a.sent();
                        _a.label = 5;
                    case 5:
                        if (!(pData != null)) return [3 /*break*/, 7];
                        return [4 /*yield*/, this.loadCatalogImages(pContext, pData)];
                    case 6:
                        _a.sent();
                        _a.label = 7;
                    case 7: return [2 /*return*/];
                }
            });
        });
    };
    AppModule.prototype.saveDocumentData = function (pContext, pOptions) {
        return __awaiter(this, void 0, void 0, function () {
            var tModuleData, tUrl, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (pContext == null)
                            return [2 /*return*/, (null)];
                        if (!pOptions.embedAppModuleResources) return [3 /*break*/, 4];
                        tModuleData = {};
                        return [4 /*yield*/, this.mArticleManager.saveToObk(false)];
                    case 1:
                        tUrl = _b.sent();
                        if (isNullOrEmpty(tUrl))
                            throw new Error("Failed to get obk url.");
                        return [4 /*yield*/, pContext.addResourceFromUrl(tUrl, "project.obk", true, false)];
                    case 2:
                        _b.sent();
                        //save catalog images
                        _a = tModuleData;
                        return [4 /*yield*/, this.saveCatalogImages(pContext)];
                    case 3:
                        //save catalog images
                        _a.catalogImages = _b.sent();
                        return [2 /*return*/, (tModuleData)];
                    case 4: return [2 /*return*/, (null)]; //no other data
                }
            });
        });
    };
    //// internal //////////////////////////////////////////////////////////////////////////////
    /** @internal */
    AppModule._GetCatalogImageIndex = function (pImageId, pContext) {
        if (isNullOrEmpty(pImageId) || pContext == null)
            return (null);
        var tMap = pContext.customState.getData(AppModule.MODULE_KEY, AppModule.STATE_CATALOGIMG_INDEX_MAP);
        if (tMap == null)
            return (null);
        return (tMap.get(pImageId));
    };
    /** @internal */
    AppModule._GetCatalogImageByIndex = function (pIndex, pContext) {
        if (pIndex == null || pContext == null)
            return (null);
        var tArray = pContext.customState.getData(AppModule.MODULE_KEY, AppModule.STATE_CATALOGIMG_INDEX_ARRAY);
        if (tArray == null)
            return (null);
        return (tArray[pIndex]);
    };
    AppModule.prototype.saveCatalogImages = function (pContext) {
        return __awaiter(this, void 0, void 0, function () {
            var tIdSet, tMainArticles, _i, tMainArticles_1, tArticle, tSubArticles, _a, tSubArticles_1, tSubArticle, tCatalogImages, tIndexMap, tIds, tIter, tId, tImage, tPath;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        tIdSet = new Set();
                        tMainArticles = this.mArticleManager.getAllMainArticles();
                        for (_i = 0, tMainArticles_1 = tMainArticles; _i < tMainArticles_1.length; _i++) {
                            tArticle = tMainArticles_1[_i];
                            if (tArticle.basketId != null) {
                                tIdSet.add(tArticle._getCatalogImageId(tArticle.basketId));
                                tSubArticles = tArticle.getSubArticles(false);
                                for (_a = 0, tSubArticles_1 = tSubArticles; _a < tSubArticles_1.length; _a++) {
                                    tSubArticle = tSubArticles_1[_a];
                                    if (tSubArticle.basketId != null)
                                        tIdSet.add(tArticle._getCatalogImageId(tSubArticle.basketId));
                                }
                            }
                        }
                        tCatalogImages = new Array();
                        tIndexMap = new Map();
                        tIds = tIdSet.values();
                        tIter = tIds.next();
                        _b.label = 1;
                    case 1:
                        if (!!tIter.done) return [3 /*break*/, 4];
                        tId = tIter.value;
                        tImage = this.mArticleManager._getCatalogImageFromCache(tId);
                        if (!(tImage != null && tId != null)) return [3 /*break*/, 3];
                        tPath = this.getCatalogImageResourcePath(tId, tImage.name);
                        return [4 /*yield*/, pContext.addResource(tImage.data, tPath, false)];
                    case 2:
                        _b.sent();
                        tIndexMap.set(tId, tCatalogImages.length);
                        tCatalogImages.push({
                            id: tId,
                            name: tImage.name
                        });
                        _b.label = 3;
                    case 3:
                        tIter = tIds.next();
                        return [3 /*break*/, 1];
                    case 4:
                        pContext.customState.setData(AppModule.MODULE_KEY, AppModule.STATE_CATALOGIMG_INDEX_MAP, tIndexMap);
                        return [2 /*return*/, (tCatalogImages)];
                }
            });
        });
    };
    AppModule.prototype.loadCatalogImages = function (pContext, pData) {
        return __awaiter(this, void 0, void 0, function () {
            var tIndexArray, _i, _a, tIOCatImg, tPath, tData, pError_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (pData == null || pData.catalogImages == null)
                            return [2 /*return*/];
                        tIndexArray = new Array();
                        _i = 0, _a = pData.catalogImages;
                        _b.label = 1;
                    case 1:
                        if (!(_i < _a.length)) return [3 /*break*/, 6];
                        tIOCatImg = _a[_i];
                        _b.label = 2;
                    case 2:
                        _b.trys.push([2, 4, , 5]);
                        tIndexArray.push(tIOCatImg.id);
                        tPath = this.getCatalogImageResourcePath(tIOCatImg.id, tIOCatImg.name);
                        return [4 /*yield*/, pContext.getResource(tPath, true)];
                    case 3:
                        tData = _b.sent();
                        if (tData != null)
                            this.mArticleManager._addCatalogImageToCache(tIOCatImg.id, {
                                data: tData,
                                name: tIOCatImg.name
                            });
                        return [3 /*break*/, 5];
                    case 4:
                        pError_1 = _b.sent();
                        Log.error("Failed to load catalog image " + tIOCatImg.id, pError_1);
                        return [3 /*break*/, 5];
                    case 5:
                        _i++;
                        return [3 /*break*/, 1];
                    case 6:
                        pContext.customState.setData(AppModule.MODULE_KEY, AppModule.STATE_CATALOGIMG_INDEX_ARRAY, tIndexArray);
                        return [2 /*return*/];
                }
            });
        });
    };
    AppModule.prototype.getCatalogImageResourcePath = function (pId, pName) {
        return ("catalogimages/" + pId + getFileExtension(pName).toLowerCase());
    };
    AppModule.MODULE_KEY = "egr.wcf.cf";
    //// private ///////////////////////////////////////////////////////////////////////////////
    AppModule.STATE_CATALOGIMG_INDEX_MAP = "catalogImgIndexMap";
    AppModule.STATE_CATALOGIMG_INDEX_ARRAY = "IndexCatalogImgArray";
    return AppModule;
}(CoreAppModule));
export { AppModule };
